export default {
  label: {
    title: 'Importar arquivo',
    file: 'Arquivo',
    insertFile: 'Selecione o documento',
    link: 'Link de acesso ao documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    select: 'Selecionar',
    send: 'Enviar',
    clear: 'Limpar',
    date: 'Data do documento',
    checkbox: 'Mascarado',
    invalidLink: 'Link inválido',
    requiredValue: 'Valor obrigatório',
  },

  infoLabel: 'Informações do formulário',
  closeLabel: 'Fechar informações',

  upload: {
    error: 'Não conseguimos carregar o documento. Favor conferir os dados e tentar novamente. Caso persista, entre em contato com o suporte',
    success: 'Documento carregado com sucesso',
    duplicated: 'Este documento já foi previamente inserido',
  },

  faq: {
    title: 'O que é?',
    description: 'Formulário utilizado para importação de arquivos em pdf para leitura dos dados.',
  },
  faq2: {
    title: 'Como utilizar?',
    description: 'Selecione o arquivo na sua máquina no primeiro campo. No segundo campo insira o link de acesso ao arquivo. No terceiro campo selecione a data do documento. Por fim, selecione se o documento tem informações tarjadas.',
  },
  faq3: {
    title: 'Como redefinir o formulário?',
    description: 'Para limpar o formulário, clique no botão limpar. Quando uma importação é realizada com sucesso, o formulário redefine automaticamente.',
  },
  faq4: {
    title: 'O que acontece se a importação falhar?',
    description: 'Se uma importação falhar, uma mensagem de erro será exibida. Redefina o formulário, verifique as informações e tente novamente.',
  },
  faq5: {
    title: 'Quanto tempo demora para importação de um arquivo?',
    description: 'Existe um tempo de espera de 30 segundos para inserção dos dados na tabela.',
  },
  faq6: {
    title: 'Posso importar mais de um arquivo?',
    description: 'A importação pode comportar mais de um arquivo. Porém, caso um documento esteja dividido em mais de um arquivo, ele será registrado como dois documentos diferentes.',
  },
};
